"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
const DefaultCarrier = props => {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 23.0027C5 23.0027 6.35996 22.8546 8.60862 20.8483C13.1194 16.8088 19.2056 7.51795 19.2056 7.51795C19.2056 7.51795 20.1212 6.0368 21.2253 5.98294C22.3294 5.92908 25.7361 5.79443 25.7361 5.79443L21.6697 23.0431C21.6697 23.0296 6.48115 23.0296 5 23.0027Z",
    fill: "#979797"
  }));
};
var _default = exports.default = DefaultCarrier;